import * as types from "../constants/ActionTypes";

export const fatalError = messageDescriptor => ({
  type: types.FATAL_ERROR,
  messageDescriptor
});
